import { Box } from "@mui/material";
import React, { useState } from "react";
import RequestTable from "./table";
import { RequestModal } from "./request-modal";

const RequestContent = ({
  request_list,
  handleRefresh,
  loading,
}: {
  request_list: any[];
  handleRefresh: () => void;
  loading: boolean;
}) => {
  const [modal_content, setModal_content] = useState({
    content: {},
    modal: false,
  });
  const handleOpenModal = (data: any) => {
    setModal_content({ content: data, modal: true });
  };
  const handleCloseModal = () => {
    setModal_content({ content: {}, modal: false });
  };
  return (
    <Box sx={{ p: 3 }}>
      <RequestModal
        open={modal_content?.modal}
        content={modal_content?.content}
        handleModal={handleCloseModal}
        handleRefresh={handleRefresh}
        
      />
      <RequestTable handleOpenModal={handleOpenModal} data={request_list} loading={loading} />
    </Box>
  );
};

export default RequestContent;
